module.exports = __webpack_public_path__ + "img/J&JGrey-01.29d91258.png";